var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{attrs:{"fullWidth":true,"inputDate":_vm.currentValue},on:{"select":function($event){return _vm.updateField(_vm.field, $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }